import apiClient from "./apiClient";

export default {
  async getExtraChargeReport(params = {}) {
    return apiClient.get("/reports/extracharge", { params });
  },
  async getRoomSoldReport(params = {}) {
    return apiClient.get("/room-sold-report", { params });
  },
};